import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import 'react';
import { ButtonContents } from '../../style.js';
import Style from './style.js';
import { jsx } from '@emotion/react';

var _excluded = ["children", "disabled", "onClick"];
var TextButton = _ref => {
  var {
    children,
    disabled = false,
    onClick = () => undefined
  } = _ref,
      rest = _objectWithoutProperties(_ref, _excluded);

  return jsx(Style.BaseTextButton, _extends({
    disabled: disabled,
    onClick: !disabled ? onClick : event => {
      event.preventDefault();
    } // eslint-disable-next-line react/jsx-props-no-spreading

  }, rest), jsx(ButtonContents, {
    hasIcon: false,
    isFullWidth: false,
    isLoading: false
  }, children));
};

export { TextButton };
